export const countries = [
	{ name: 'Denmark', longCode: 'DNK', code: 'DK', language: 'da' },
	{ name: 'Sweden', longCode: 'SWE', code: 'SE', language: 'sv' },
	{ name: 'Finland', longCode: 'FIN', code: 'FI', language: 'da' },
	{ name: 'Norway', longCode: 'NOR', code: 'NO', language: 'no' },
	{ name: 'Austria', longCode: 'AUT', code: 'AT', language: 'de' },
	{ name: 'Belgium', longCode: 'BEL', code: 'BE', language: 'nl' },
	{ name: 'Bulgaria', longCode: 'BGR', code: 'BG', language: 'bg' },
	{ name: 'Croatia', longCode: 'HRV', code: 'HR', language: 'hr' },
	{ name: 'Cyprus', longCode: 'CYP', code: 'CY', language: 'el' },
	{ name: 'Czech Republic', longCode: 'CZE', code: 'CZ', language: 'cs' },
	{ name: 'Estonia', longCode: 'EST', code: 'EE', language: 'et' },
	{ name: 'France', longCode: 'FRA', code: 'FR', language: 'fr' },
	{ name: 'Germany', longCode: 'DEU', code: 'DE', language: 'de' },
	{ name: 'Greece', longCode: 'GRC', code: 'GR', language: 'el' },
	{ name: 'Hungary', longCode: 'HUN', code: 'HU', language: 'hu' },
	{ name: 'Ireland', longCode: 'IRL', code: 'IE', language: 'ga' },
	{ name: 'Italy', longCode: 'ITA', code: 'IT', language: 'it' },
	{ name: 'Latvia', longCode: 'LVA', code: 'LV', language: 'lv' },
	{ name: 'Lithuania', longCode: 'LTU', code: 'LT', language: 'lt' },
	{ name: 'Luxembourg', longCode: 'LUX', code: 'LU', language: 'fr' },
	{ name: 'Malta', longCode: 'MLT', code: 'MT', language: 'mt' },
	{ name: 'Netherlands', longCode: 'NLD', code: 'NL', language: 'nl' },
	{ name: 'Poland', longCode: 'POL', code: 'PL', language: 'pl' },
	{ name: 'Portugal', longCode: 'PRT', code: 'PT', language: 'pt' },
	{ name: 'Romania', longCode: 'ROU', code: 'RO', language: 'ro' },
	{ name: 'Slovakia', longCode: 'SVK', code: 'SK', language: 'sk' },
	{ name: 'Slovenia', longCode: 'SVN', code: 'SI', language: 'sl' },
	{ name: 'Spain', longCode: 'ESP', code: 'ES', language: 'es' },
];

export function getCurrentCountryForMarket() {
	const market = process.env.GATSBY_MARKET;
	const country = countries.find(x => x.code.toLowerCase() === market);
	return country?.name;
}

export function getCurrentCountryCodeForMarket() {
	const market = process.env.GATSBY_MARKET;
	const country = countries.find(x => x.code.toLowerCase() === market);
	return country?.code.toLowerCase();
}

export function getCurrentCountryLongCodeForMarket() {
	const market = process.env.GATSBY_MARKET;
	const country = countries.find(x => x.code.toLowerCase() === market);
	return country?.longCode;
}

export function getLocaleForLanguage(language) {
	const country = countries.find(x => x.language === language);
	return country ? `${country.language}_${country.code}` : 'sv_SE';
}
